import { Box, Heading, NewsworthyItem, NewsworthyScrollbarsContainer } from "@govlaunch/web";
import { BoxProps } from "@govlaunch/web/src/box/Box";
import React from "react";
import { IProductFieldsFragment } from "../fragments/__generated__/ProductFieldsFragment.generated";
import { FormattedMessage } from "react-intl";

interface IProductNewsworthyProps extends BoxProps {
  product: IProductFieldsFragment;
  stacked?: boolean;
}

export default function ProductNewsworthy({ product, stacked, ...props }: IProductNewsworthyProps) {
  if (!product.newsworthy || product.newsworthy.length === 0) {
    return null;
  }

  return (
    <Box display="grid" {...props}>
      <Heading as="h3" fontWeight="bold" fontSize="lg" pl={[0, 0, 8]}>
        <FormattedMessage defaultMessage="Newsworthy" id="JhItYg" />
      </Heading>

      <NewsworthyScrollbarsContainer stacked={stacked} mt={1}>
        {product.newsworthy.map((newsworthy) => {
          return (
            <NewsworthyItem
              key={newsworthy.url || Math.random().toString(16)}
              newsworthy={{
                url: newsworthy.url || "",
                description: newsworthy.description,
                favicon: newsworthy.favicon,
                title: newsworthy.title || "",
                siteName: newsworthy.siteName || "",
              }}
              flexDirection={product.newsworthy?.length === 1 ? "column" : "row"}
            />
          );
        })}
      </NewsworthyScrollbarsContainer>
    </Box>
  );
}
